export { default as ProductsElasticSearchContent } from './ProductsElasticSearchContent';
